
      import BugsnagPerformance from '//d2wy8f7a9ursnm.cloudfront.net/v1/bugsnag-performance.min.js'

      // Get app version from meta tag or default to '1.0.0'
      const appVersion = document.querySelector('meta[name="app-version"]')?.getAttribute('content') || '1.0.0';

      BugsnagPerformance.start({
        apiKey: 'fe8dd4c886f45623657f94e003c5aef4',
        appVersion: appVersion,
        // Auto-detect release stage based on hostname
        releaseStage: window.location.hostname === 'diiivorce.com' ? 'production' :
                      window.location.hostname.includes('staging') ? 'staging' : 'development',
        // Only send performance data in production and staging
        enabledReleaseStages: ['production', 'staging'],
        // Configure performance thresholds
        settleIgnoreUrls: [
          // Ignore performance tracking for health check endpoints
          /\/health/,
          /\/ping/
        ],
        // Track route changes for SPA navigation
        autoInstrumentRouteChanges: true,
        // Track network requests
        autoInstrumentNetworkRequests: true,
        // Set performance budgets (in milliseconds)
        performanceBudgets: {
          // Page load should complete within 3 seconds
          pageLoad: 3000,
          // Route changes should complete within 1.5 seconds
          routeChange: 1500,
          // Network requests should complete within 5 seconds
          networkRequest: 5000
        }
      });
    